import randomColor from "../Enums/Colors";

export const getColor = (value: number) => {
	return randomColor[value];
};

export const getColumnColor = (value: number) => {
	return randomColor[value * 20];
};

export const getStatusColor = (value: number) => {
	return randomColor[(value-1) * 10];
}